import React from 'react';
import { extractYouTubeVideoId } from '../util/util';

function getText(html){
  var divContainer= document.createElement("div");
  divContainer.innerHTML = html;
  return divContainer.textContent || divContainer.innerText || "";
}

// 리스트에서 클릭되는 비디오의 객제를 넘겨 받아서 세부 정보를 표현 하는 곳.
const VideoDetail = ({ video }) => {
  if (video == null) {
    return <div>Loading...</div>
  }

  const videoId = extractYouTubeVideoId(video.youtube_url);

  const youtubeLink = `https://www.youtube.com/embed/${videoId}`;

  // <p dangerouslySetInnerHTML={{__html: video.post_content}}></p>

  return (
    <div>
      <div className="ui embed">
        <iframe title="youtube video" src={youtubeLink}></iframe>
      </div>
      <div className="ui segment">
        <h3>{video.title}</h3>
        <p>{getText(video.post_content)}</p>
        { video.url &&
          <div>
            <i className="chevron circle right icon"></i> <a href={video.url} target='_blank'>게시글</a>
          </div>
        }
      </div>
    </div>
  );
}

export default VideoDetail;
